import React from 'react';
import PropTypes from 'prop-types';
import { Tile, TileContent, TileText } from '@one-thd/sui-atomic-components';
import { AssistantIcon } from '../../../assets/AssistantIcon';

const TileButton = ({
  label,
  value,
  onClick,
  truncate,
  withIcon = true,
  ...props
}) => {
  // eslint-disable-next-line max-len
  const pillClasses = 'sui-bg-primary sui-rounded-lg sui-border-solid sui-rounded-base sui-text-primary hover:sui-outline hover:sui-outline-2 hover:-sui-outline-offset-2 focus-visible:sui-outline focus-visible:sui-outline-input-focus focus-visible:sui-outline-4 focus-visible:-sui-outline-offset-4 sui-border-1 sui-p-[7px] sui-border-input-primary hover:sui-outline-button-hover-accent';

  return (
    <Tile
      className={pillClasses}
      onClick={onClick}
      value={value}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <TileContent>
        {withIcon && <AssistantIcon height="16px" width="16px" color="brand" />}
        <TileText truncate={truncate}>{label || value}</TileText>
      </TileContent>
    </Tile>
  );
};

TileButton.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  truncate: PropTypes.bool,
  withIcon: PropTypes.bool,
};

TileButton.defaultProps = {
  label: '',
  truncate: false,
  withIcon: false,
};

export { TileButton };
